export const API_BASENAME = `${process.env.REACT_APP_API_URL}`;